import { Transform, Type } from "class-transformer";
import { IsNotEmpty } from "class-validator";
import { AddressValidator } from "../validators/address-validator";

export class Address {

    @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
    @IsNotEmpty({ message: 'validation.please_select_your_country' })
    address_country: string;

    @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
    @AddressValidator('line1')
    line1: string;

    @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
    @AddressValidator('line2')
    line2: string;

    @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
    @AddressValidator('postcode')
    postcode: string;

    @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
    @AddressValidator('state')
    state: string;

    @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
    @AddressValidator('city')
    city: string;
}
